import { render, staticRenderFns } from "./ProductCheckForm.vue?vue&type=template&id=2f064de4&scoped=true&"
import script from "./ProductCheckForm.vue?vue&type=script&lang=js&"
export * from "./ProductCheckForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f064de4",
  null
  
)

export default component.exports